import readXlsxFile, { Row } from "read-excel-file";

export async function readExcelFile(file: File): Promise<Row[]> {
  const rows = readXlsxFile(file).catch((error) => {
    console.error("Error reading Excel file:", error);
    return Promise.reject(error);
  });

  return Promise.resolve(rows);
}